import Vue from 'vue';
import Router from 'vue-router';

Vue.use(Router);

export const routers =
  [{
    path: '/',
    redirect: '/center',
    component: () => import('@/views/main.vue'),
    children: [{
      path: '/',
      redirect: '/center',
      component: () => import('@/views/home/home.vue'),
      children: [{ // 中转页
        path: '/center',
        name: 'center',
        component: () => import('@/views/center/index.vue'),
        meta: {keepAlive: false, needCache: true, scrollTop: 0},
      },
        { // 微主页
          path: '/show',
          name: 'show',
          component: () => import('@/views/show/index.vue'),
          meta: {keepAlive: true, needCache: true},
        },
        { // 分类
          path: '/goods',
          name: 'goods',
          component: () => import('@/views/goods/goodsclass.vue'),
          meta: {keepAlive: true, needCache: true},
        },
        { // 购物车
          path: '/cart',
          name: 'cart',
          component: () => import('@/views/cart/index.vue'),
          // meta: { returnNeedCache: true },
        },
        { // 个人中心
          path: '/user',
          name: 'user',
          component: () => import('@/views/user/index.vue'),
          meta: {keepAlive: true},
        },
      ],
    },
      {
        path: '/confirmorderbase',
        redirect: '/confirmorder',
        component: () => import('@/views/home/confirmorderbase.vue'),
        children: [{ // 普通确认
          path: '/confirmorder',
          name: 'confirmorder',
          component: () => import('@/views/order/confirmorder.vue'),
        },
          { // 立即购买
            path: '/confirmorderwithoutcart',
            name: 'confirmorderwithoutcart',
            component: () => import('@/views/order/confirmorderwithoutcart.vue'),
          },
          { // 立即购买  秒杀
            path: '/seckillConfirmOrder',
            name: 'confirmorderwithoutcart',
            component: () => import('@/views/order/seckillConfirmOrder.vue'),
          },
          { // 立即购买  拼团
            path: '/spellConfirmOrder/:type',
            name: 'confirmorderwithoutcart',
            component: () => import('@/views/order/spellConfirmOrder.vue'),
          },
          { // 立即购买  砍价
            path: '/bargainConfirmOrder',
            name: 'confirmorderwithoutcart',
            component: () => import('@/views/order/bargainConfirmOrder.vue'),
          },
          { // 拼团分享
            path: '/spellShareDetail/:order',
            name: 'spellShareDetail',
            component: () => import('@/views/order/spellShareDetail.vue'),
          },
          { // 拼团分享
            path: '/bargainShareDetail/:order',
            name: 'bargainShareDetail',
            component: () => import('@/views/order/bargainShareDetail.vue'),
          },
          { // 积分确认
            path: '/confirmpointorder',
            name: 'confirmpointorder',
            component: () => import('@/views/order/confirmpointorder.vue'),
            meta: {returnNeedCache: false},
          },
          { // 拼团确认
            path: '/spellgrouporder',
            name: 'spellgrouporder',
            component: () => import('@/views/order/spellgrouporder.vue'),
            meta: {keepAlive: false},
          },
          { // 商品详情
            path: '/details/:id',
            name: 'details',
            component: () => import('@/views/cart/details.vue'),
            meta: {keepAlive: false, returnNeedCache: true},
          },
          { // 新人购详情
            path: '/newpeoplebuydetail/:id/:itemno',
            name: 'newpeoplebuydetail',
            component: () => import('@/views/cart/newpeoplebuydetail.vue'),
            meta: {keepAlive: false, returnNeedCache: true},
          },
          {
            // 订单详情
            path: '/oederdetails',
            name: 'oederdetails',
            component: () => import('@/views/order/oederdetails.vue'),
            meta: {returnNeedCache: true},
          },
          {
            // 收银台
            path: '/checkstand',
            name: 'checkstand',
            component: () => import('@/views/pay/checkstand.vue'),
          },
          {
            // 支付成功
            path: '/success',
            name: 'success',
            component: () => import('@/views/pay/success.vue'),
          },
          {
            // 拼团列表
            path: '/spellgrouplist',
            component: () => import('@/views/goods/spellgrouplist.vue'),
            name: 'spellgrouplist',
            meta: {keepAlive: true, needCache: true},
          },
          { // 拼团详情
            path: '/groupdetail/:id/:itemno',
            name: 'groupdetail',
            component: () => import('@/views/cart/groupdetail.vue'),
            meta: {returnNeedCache: true},
          },
          { // 参团详情
            path: '/joingroupdetail/:id/:itemno/:order/:teamNum',
            name: 'joingroupdetail',
            component: () => import('@/views/cart/groupdetail.vue'),
            meta: {returnNeedCache: true},
          },
          { // 拼团详情
            path: '/grouporderdetail/:orderno',
            name: 'grouporderdetail',
            component: () => import('@/views/cart/grouporderdetail.vue'),
            meta: {returnNeedCache: true},
          },
          { // 拼团列表
            path: '/ordergroup/:id/:itemno',
            name: 'ordergroup',
            component: () => import('@/views/cart/ordergroup.vue'),
            meta: {returnNeedCache: true},
          },
          { // 砍价详情
            path: '/bargaindetail/:id/:itemno',
            name: 'bargaindetail',
            component: () => import('@/views/cart/bargaindetail.vue'),
            meta: {returnNeedCache: true},
          },
          {
            // 砍价列表
            path: '/bargainlist',
            component: () => import('@/views/goods/bargainlist.vue'),
            name: 'bargainlist',
            meta: {keepAlive: true, needCache: true},
          },
          {
            // 秒杀列表
            path: '/seckilllist',
            component: () => import('@/views/goods/seckilllist.vue'),
            name: 'seckilllist',
            meta: {keepAlive: true, needCache: true},
          },
          { // 秒杀详情
            path: '/seckilldetail/:id',
            name: 'seckilldetail',
            component: () => import('@/views/cart/seckilldetail.vue'),
            meta: {returnNeedCache: true},
          },
          {
            // 促销列表
            path: '/limitedlist',
            component: () => import('@/views/goods/limitedlist.vue'),
            name: 'limitedlist',
            meta: {keepAlive: true, needCache: true},
          },
          {
            // 新人购列表
            path: '/newpeoplebuylist',
            component: () => import('@/views/goods/newpeoplebuylist.vue'),
            name: 'newpeoplebuylist',
            meta: {keepAlive: true, needCache: true},
          },
          {
            // 加价购列表
            path: '/addpricebuylist',
            name: 'addpricebuylist',
            component: () => import('@/views/goods/addpricebuylist.vue'),
            meta: {returnNeedCache: true},
          },
          {
            // 加价购详情
            path: '/addpricebuydetail/:id',
            name: 'addpricebuydetail',
            component: () => import('@/views/cart/addpricebuydetail.vue'),
            meta: {returnNeedCache: true},
          },
          {
            // 加价购换购商品列表
            path: '/addpricebuycart/:id',
            name: 'addpricebuycart',
            component: () => import('@/views/cart/addpricebuycart.vue'),
            meta: {returnNeedCache: true},
          },
          {
            // 预售列表
            path: '/preorderlist',
            component: () => import('@/views/goods/preorderlist.vue'),
            name: 'preorderlist',
            meta: {keepAlive: true, needCache: true},
          },
          { // 预售详情
            path: '/preorderdetail/:id',
            name: 'predetails',
            component: () => import('@/views/cart/predetails.vue'),
            meta: {returnNeedCache: true},
          },
          {
            // 满减列表
            path: '/buyfullpromotionlist',
            component: () => import('@/views/goods/buyfullpromotionlist.vue'),
            name: 'buyfullpromotionlist',
            meta: {keepAlive: true, needCache: true},
          },
          { // 满减详情
            path: '/buyfullpromotiondetail/:id/:itemno',
            name: 'buyfullpromotiondetail',
            component: () => import('@/views/goods/buyfullpromotiondetail.vue'),
            meta: {returnNeedCache: true},
          },
          { // 商品列表
            path: '/goodslist',
            component: () => import('@/views/goods/goodslist.vue'),
            name: 'goodslist',
            meta: {keepAlive: true, needCache: true},
          },
          { // 商品列表 有商品编号过滤
            path: '/goodslist/p:id',
            component: () => import('@/views/goods/goodslist.vue'),
            name: 'goodslistp',
            meta: {keepAlive: true, needCache: true},
          },
          { // 商品列表 有商品类别过滤
            path: '/goodslist/c:id',
            component: () => import('@/views/goods/goodslist.vue'),
            name: 'goodslistc',
            meta: {keepAlive: true, needCache: true},
          },
          { // 商品列表 有商品品牌过滤
            path: '/goodslist/b:id',
            component: () => import('@/views/goods/goodslist.vue'),
            name: 'goodslistb',
            meta: {keepAlive: true, needCache: true},
          },
          { // 商品列表 有活动过滤
            path: '/goodslist/activity/:id',
            component: () => import('@/views/goods/goodslist.vue'),
            name: 'goodslistactivity',
            meta: {keepAlive: true, needCache: true},
          },
          // { // 中奖记录
          //     path: '/winningrecord',
          //     name: 'winningrecord',
          //     component: () => import('@/views/user/winningrecord.vue'),
          // },
          { // 我的收藏
            path: '/collection',
            component: () => import('@/views/user/collection.vue'),
            name: 'collection',
            meta: {keepAlive: true, needCache: true},
          },
          { // 积分商城
            path: '/intergralmall',
            name: 'intergralmall',
            component: () => import('@/views/user/intergralmall.vue'),
            //meta: { keepAlive: true, needCache:true },
          },
          { // 默认门店
            path: '/defaultstores',
            name: 'defaultstores',
            component: () => import('@/views/user/defaultstores.vue'),
          },
          { // 签到中心
            path: '/checkin',
            name: 'checkin',
            component: () => import('@/views/user/checkin.vue'),
          },
          { // 注册有礼
            path: '/registergift',
            name: 'registergift',
            component: () => import('@/views/user/registergift.vue'),
          },
          { // 在线咨询
            path: '/chatindex',
            name: 'chatindex',
            component: () => import('@/views/customchat/chatindex.vue'),
          },
          { // 客服人员中心
            path: '/contactus',
            name: 'contactus',
            component: () => import('@/views/user/contactus.vue'),
          },
          { // 积分订单购物车
            path: '/giftcart',
            name: 'giftcart',
            component: () => import('@/views/cart/giftcart.vue'),
            meta: {returnNeedCache: true},
          },
          { // 积分订单详情
            path: '/creditorderdetails',
            name: 'creditorderdetails',
            component: () => import('@/views/order/creditorderdetails.vue'),
            meta: {returnNeedCache: true},
          },
          { // 积分商品详情
            path: '/giftdetails/:giftno',
            name: 'giftdetails',
            component: () => import('@/views/cart/giftdetails.vue'),
            meta: {returnNeedCache: true},
          },
          { // 地址选择页面
            path: '/selectaddresslist',
            name: 'selectaddresslist',
            component: () => import('@/component/AddressList/SelectAddressList.vue'),
          },
          { // 选择收货地址编辑
            path: '/selectaddressedit/:id',
            name: 'selectaddressedit',
            component: () => import('@/component/AddressEdit/SelectAddressEdit.vue'),
            meta: {keepAlive: true, needCache: true},
          },
          { // 取消订单
            path: '/cancelorder/:orderno',
            name: 'cancelorder',
            component: () => import('@/views/order/cancelorder.vue'),
          },
          { // 通知中心
            path: '/notificationcenter',
            name: 'notificationcenter',
            component: () => import('@/views/user/notificationcenter.vue'),
          },
          { // 积分订单
            path: '/integralorders',
            name: 'integralorders',
            component: () => import('@/views/user/integralorders.vue'),
            meta: {keepAlive: true, needCache: true},
          },
          { // 积分订单详情
            path: '/integralorderdetail',
            name: 'integralorderdetail',
            component: () => import('@/views/user/integralorderdetail.vue'),
          },
          { // 积分订单
            path: '/bargainorders',
            name: 'bargainorders',
            component: () => import('@/views/user/bargainorders.vue'),
          },
          { // 券包订单
            path: '/voucherorders',
            name: 'voucherorders',
            component: () => import('@/views/user/voucherorders.vue'),
          },
          { // 券包订单详情
            path: '/voucherorderdetail',
            name: 'voucherorderdetail',
            component: () => import('@/views/user/voucherorderdetail.vue'),
          },
          { // 门店订单 更改为电子小票
            path: '/storeorders',
            name: 'storeorders',
            component: () => import('@/views/user/storeorders.vue'),
          },
          { // 计次项目充值
            path: '/secondaryrecharge',
            name: 'secondaryrecharge',
            component: () => import('@/views/user/secondaryrecharge.vue'),
          },
          { // 计次项目充值详情
            path: '/secondaryrechargedetail/:serverid',
            name: 'secondaryrechargedetail',
            component: () => import('@/views/user/secondaryrechargedetail.vue'),
          },
          { // 我的计次
            path: '/myremember',
            name: 'myremember',
            component: () => import('@/views/user/myremember.vue'),
          },
          { // 明细计次
            path: '/myrememberdetail/:sheetno',
            name: 'myrememberdetail',
            component: () => import('@/views/user/myrememberdetail.vue'),
          },
          { // 我的寄存
            path: '/myhosting',
            name: 'myhosting',
            component: () => import('@/views/user/myhosting.vue'),
          },
          { // 寄存明细
            path: '/myhostingdetail/:flowno',
            name: 'myhostingdetail',
            component: () => import('@/views/user/myhostingdetail.vue'),
          },
          { // 我是营销员
            path: '/marketingstaff',
            name: 'marketingstaff',
            component: () => import('@/views/marketingstaff/marketingstaff.vue'),
          },
          { // 我是营销员 我的会员
            path: '/mymenber',
            name: 'mymenber',
            component: () => import('@/views/marketingstaff/mymenber.vue'),
            // meta: { keepAlive: true, needCache: true },
          },
          { // 我是营销员 会员分析
            path: '/menberanalysis',
            name: 'menberanalysis',
            component: () => import('@/views/marketingstaff/menberanalysis.vue'),
          },
          { // 我是营销员 当前任务
            path: '/currenttask',
            name: 'currenttask',
            component: () => import('@/views/marketingstaff/currenttask.vue'),
          },
          { // 我是营销员 会员概况
            path: '/vipInfotask',
            name: 'vipInfotask',
            component: () => import('@/views/marketingstaff/vipInfotask.vue'),
          },
          { // 我是营销员 任务登记表
            path: '/taketoform',
            name: 'taketoform',
            component: () => import('@/views/marketingstaff/taketoform.vue'),
          },
          { // 我是营销员 任务登记列表
            path: '/taskregisterlist',
            name: 'taskregisterlist',
            component: () => import('@/views/marketingstaff/taskregisterlist.vue'),
          },
          { // 我是营销员 沟通记录
            path: '/membervisit',
            name: 'membervisit',
            component: () => import('@/views/marketingstaff/membervisit.vue'),
          },
          { // 我是营销员 券销售
            path: '/ticketsales',
            name: 'ticketsales',
            component: () => import('@/views/marketingstaff/ticketsales.vue'),
          },
          { // 我是营销员 寄存计次查询
            path: '/querytimes',
            name: 'querytimes',
            component: () => import('@/views/marketingstaff/querytimes.vue'),
          },
          { // 我是营销员 客户评价
            path: '/clientevaluate',
            name: 'clientevaluate',
            component: () => import('@/views/marketingstaff/clientevaluate.vue'),
          },
          { // 我是营销员 营销员排行
            path: '/salesman',
            name: 'salesman',
            component: () => import('@/views/marketingstaff/salesman.vue'),
          },
          { // 我是营销员 销售任务
            path: '/salestask',
            name: 'salestask',
            component: () => import('@/views/marketingstaff/salestask.vue'),
          },
          { // 我是营销员 销售任务详情
            path: '/salestaskdetail',
            name: 'salestaskdetail',
            component: () => import('@/views/marketingstaff/branchdata.vue'),
          },
          { // 我是营销员 异常日志
            path: '/errorLogs',
            name: 'errorLogs',
            component: () => import('@/views/marketingstaff/errorLogs.vue'),
          },
          { // 我是营销员 生日排行
            path: '/Birthdayranking',
            name: 'Birthdayranking',
            component: () => import('@/views/marketingstaff/Birthdayranking.vue'),
          },
          { // 我是营销员 销售额排行
            path: '/Salesranking',
            name: 'Salesranking',
            component: () => import('@/views/marketingstaff/Salesranking.vue'),
          },
          { // 我是营销员 反店次数排行
            path: '/rankingofcounterstore',
            name: 'rankingofcounterstore',
            component: () => import('@/views/marketingstaff/rankingofcounterstore.vue'),
          },
          { // 我是营销员 平均客单价排行
            path: '/Averageunitpriceranking',
            name: 'Averageunitpriceranking',
            component: () => import('@/views/marketingstaff/Averageunitpriceranking.vue'),
          },
          { // 我是营销员 年龄结构
            path: '/Agestructure',
            name: 'Agestructure',
            component: () => import('@/views/marketingstaff/Agestructure.vue'),
          },
          { // 我是营销员 异常日志详情
            path: '/errorlogsdetails/:openid',
            name: 'errorlogsdetails',
            component: () => import('@/views/marketingstaff/errorlogsdetails.vue'),
          },
          { // 我是营销员 券销售列表
            path: '/ticketsaleslist',
            name: 'ticketsaleslist',
            component: () => import('@/views/marketingstaff/ticketsaleslist.vue'),
          },
          { // 我是营销员 优惠券列表
            path: '/couponlist',
            name: 'couponlist',
            component: () => import('@/views/marketingstaff/couponlist.vue'),
          },
          { // 我是营销员 门店数据详情
            path: '/branchdata',
            name: 'branchdata',
            component: () => import('@/views/marketingstaff/branchdata.vue'),
          },
          { // 我是营销员 会员资料
            path: '/information',
            name: 'information',
            component: () => import('@/views/marketingstaff/information.vue'),
            meta: {returnNeedCache: true},
          },
          { // 我是营销员 会员标签
            path: '/labeling',
            name: 'labeling',
            component: () => import('@/views/marketingstaff/labeling.vue'),
          },
          { // 我是营销员 数据查询
            path: '/dataquery',
            name: 'dataquery',
            component: () => import('@/views/marketingstaff/dataquery.vue'),
          },
          { // 我是营销员 最新会员消费
            path: '/recentconsumption',
            name: 'recentconsumption',
            component: () => import('@/views/marketingstaff/recentconsumption.vue'),
          },
          { // 我是营销员 会员结构
            path: '/memberstructure',
            name: 'memberstructure',
            component: () => import('@/views/marketingstaff/memberstructure.vue'),
          },
          { // 浏览记录
            path: '/browsinghistory',
            name: 'browsinghistory',
            component: () => import('@/views/user/browsinghistory.vue'),
          },
          { // 我的评价
            path: '/myevaluation',
            name: 'myevaluation',
            component: () => import('@/views/user/myevaluation.vue'),
          },
          { // 订单轨迹
            path: '/ordertrack',
            name: 'ordertrack',
            component: () => import('@/views/order/ordertrack.vue'),
          },
          { // 发表评价
            path: '/publicationevaluation',
            name: 'publicationevaluation',
            component: () => import('@/views/user/publicationevaluation.vue'),
          },
          { // 发表追评
            path: '/publicationreview',
            name: 'publicationreview',
            component: () => import('@/views/user/publicationreview.vue'),
          },
          { // 根据关键字调百度地图搜索地址列表
            path: '/searchaddress/:id',
            name: 'searchaddress',
            component: () => import('@/views/user/searchaddress.vue'),
            meta: {returnNeedCache: true},
          },
          {   //配送范围+运费规则
            path: '/freightdistance',
            name: 'freightdistance',
            component: () => import('@/views/user/freightdistance.vue'),
            meta: {returnNeedCache: true},
          },
          {   //配送范围
            path: '/freightdistancecopy',
            name: 'freightdistancecopy',
            component: () => import('@/views/user/freightdistancecopy.vue'),
            meta: {returnNeedCache: true},
          },
          {   //运费规则
            path: '/freightregion',
            name: 'freightregion',
            component: () => import('@/views/user/freightregion.vue'),
            meta: {returnNeedCache: true},
          },
          {   //运费规则+配送区域
            path: '/freightregioncopy',
            name: 'freightregioncopy',
            component: () => import('@/views/user/freightregioncopy.vue'),
            meta: {returnNeedCache: true},
          },
          {   //门店配送区域
            path: '/deliveryRegion',
            name: 'deliveryRegion',
            component: () => import('@/views/user/deliveryRegion.vue'),
            meta: {returnNeedCache: true},
          },
          {   //门店配送距离
            path: '/freightdistancecopy',
            name: 'freightdistancecopy',
            component: () => import('@/views/user/freightdistancecopy.vue'),
            meta: {returnNeedCache: true},
          },
          {   //门店导航
            path: '/navigation',
            name: 'navigation',
            component: () => import('@/views/user/navigation.vue'),
            meta: {returnNeedCache: true},
          },
          { // 搜索列表
            path: '/searchindex',
            name: 'searchindex',
            component: () => import('@/views/show/searchindex.vue'),
            meta: {returnNeedCache: true},
          },
          { // 商品详情
            path: '/goodsdetails/:id',
            name: 'goodsdetails',
            component: () => import('@/views/cart/goodsdetails.vue'),
            meta: {keepAlive: false, returnNeedCache: true},
          },
          { // 评价列表
            path: '/appraise/:id',
            name: 'appraise',
            component: () => import('@/views/cart/appraise.vue'),
            meta: {keepAlive: false, returnNeedCache: true},
          },
          { // 秒杀评价列表
            path: '/seckillAppraise/:id',
            name: 'seckillAppraise',
            component: () => import('@/views/cart/seckillAppraise.vue'),
            meta: {keepAlive: false, returnNeedCache: true},
          },
          { // 购物车
            path: '/carttest',
            name: 'carttest',
            component: () => import('@/views/cart/index.vue'),
          },
          { // 联系人
            path: '/user/contact',
            name: 'contact',
            component: () => import('@/component/Contact/Contact.vue'),
          },
          { // 收货地址
            path: '/addresslist',
            name: 'addresslist',
            component: () => import('@/component/AddressList/AddressList.vue'),
          },
          { // 收货地址编辑
            path: '/addressedit/:id',
            name: 'addresseditid',
            component: () => import('@/component/AddressEdit/AddressEdit.vue'),
            meta: {keepAlive: true, needCache: true},
          },
          { // 地址编辑
            path: '/addressedit',
            name: 'addressedit',
            component: () => import('@/component/AddressEdit/AddressEdit.vue'),
            meta: {keepAlive: true, needCache: true},
          },
          { // 我的订单
            path: '/user/myorder/:active',
            name: 'myorder',
            component: () => import('@/views/order/index.vue'),
            meta: {keepAlive: true, needCache: true},
          },
          { // 我的订单
            path: '/user/myordertest/:active',
            name: 'myordertest',
            component: () => import('@/views/order/index.vue'),
            meta: {keepAlive: true, needCache: true},
          },
          { // 储值卡明细
            path: '/ChargeFeeHistory',
            name: 'ChargeFeeHistory',
            component: () => import('@/views/user/ChargeFeeHistory.vue'),
          },
          { // 积分明细
            path: '/ScoreDetail',
            name: 'scoredetail',
            component: () => import('@/views/user/ScoreDetail.vue'),
          },
          { // 账户充值
            path: '/ChargeFee',
            name: 'chargefee',
            component: () => import('@/views/user/ChargeFee.vue'),
          },
          { //卡密充值
            path: '/Chargekami',
            name: 'Chargekami',
            component: () => import('@/views/pay/Chargekami.vue'),
          },
          { // 我的资料
            path: '/myprofile',
            name: 'myprofile',
            component: () => import('@/views/user/myprofile.vue'),
          },
          { // 编辑宝宝信息
            path: '/addbabyinfo',
            name: 'addbabyinfo',
            component: () => import('@/views/user/addbabyinfo.vue'),
          },
          { // 更换卡号
            path: '/changecardid',
            name: 'changecardid',
            component: () => import('@/views/user/changecardid.vue'),
          },
          {
            // 大类小类加品牌
            path: '/brandindex',
            name: 'brandindex',
            component: () => import('@/views/goods/brandindex.vue'),
          },
          {
            // 小类详情
            path: '/categorydetails',
            name: 'categorydetails',
            component: () => import('@/views/goods/categorydetails.vue'),
            meta: {keepAlive: true, needCache: true, returnNeedCache: true},
          },
          {
            // 会员注册绑定
            path: '/registerorbind',
            name: 'registerorbind',
            component: () => import('@/views/user/registerorbind.vue'),
          },
          {
            // 手动注册绑定
            path: '/rbvip',
            name: 'rbvip',
            component: () => import('@/views/user/rbvip.vue'),
          },
          {
            // 电子会员卡
            path: '/ecard',
            name: 'ecard',
            component: () => import('@/views/user/ecard.vue'),
          },
          {
            // 我的优惠券
            path: '/mycoupon',
            name: 'mycoupon',
            component: () => import('@/views/user/mycoupon.vue'),
          },
          {
            // 选择优惠券
            path: '/selectcoupons',
            name: 'selectcoupons',
            component: () => import('@/views/user/selectcoupons.vue'),
          },
          {
            // 领券中心
            path: '/getcoupon',
            name: 'getcoupon',
            component: () => import('@/views/user/getcoupon.vue'),
          },
          {
            // 券包详情
            path: '/coupondetails',
            name: 'coupondetails',
            component: () => import('@/views/user/coupondetails.vue'),
          },
          {
            // 券包详情
            path: '/voucherdetail/:id',
            name: 'voucherdetail',
            component: () => import('@/views/user/voucherdetail.vue'),
          },
          {
            // 确认订单
            path: '/confirmcoupon/:bagno',
            name: 'confirmcoupon',
            component: () => import('@/views/user/confirmcoupon.vue'),
            meta: {keepAlive: false},
          },
          {
            // 给商家留言
            path: '/leavemsg',
            name: 'leavemsg',
            component: () => import('@/views/cart/leavemsg.vue'),
          },
          {
            // 优惠券详情
            path: '/mycoupondetails/:id',
            name: 'mycoupondetails',
            component: () => import('@/views/user/mycoupondetails.vue'),
          },
          {
            // 线下优惠券详情
            path: '/myofflinecoupon/:id',
            name: 'myofflinecoupon',
            component: () => import('@/views/user/myofflinecoupon.vue'),
          },
          {
            // 优惠券领取详情
            path: '/getmycoupon/:id',
            name: 'getmycoupon',
            component: () => import('@/views/user/getmycoupon.vue'),
          },
          {
            // 收货地址
            path: '/distribution',
            name: 'distribution',
            component: () => import('@/component/AddressList/SelectAddressList.vue'),
          },
          {
            // 选择门店
            path: '/pickupinstore',
            name: 'pickupinstore',
            component: () => import('@/views/order/pickupinstore.vue'),
          },
          {
            // 选择门店  秒杀
            path: '/pickupinstore1',
            name: 'pickupinstore1',
            component: () => import('@/views/order/pickupinstore1.vue'),
          },
          { // 分享有礼
            path: '/shareregistergift',
            name: 'shareregistergift',
            component: () => import('@/views/user/shareregistergift.vue'),
          },
          { // 已邀请注册好友
            path: '/hasinvited',
            name: 'hasinvited',
            component: () => import('@/views/user/hasinvited.vue'),
          },
          { // 分销中心
            path: '/distributioncenter',
            name: 'distributioncenter',
            component: () => import('@/views/distributioncenter/index.vue'),
          },
          { // 分销订单
            path: '/distributionorder',
            name: 'distributionorder',
            component: () => import('@/views/distributioncenter/distributionorder.vue'),
          },
          { // 我的团队
            path: '/distributionteam',
            name: 'distributionteam',
            component: () => import('@/views/distributioncenter/myteam.vue'),
          },
          { // 收益记录
            path: '/distributionincome',
            name: 'distributionincome',
            component: () => import('@/views/distributioncenter/incomerecord.vue'),
          },
          { // 提现
            path: '/cashwithdrawa',
            name: 'cashwithdrawa',
            component: () => import('@/views/distributioncenter/cashwithdrawa.vue'),
          },
          { // 分销门槛
            path: '/distributionthreshold',
            name: 'distributionthreshold',
            component: () => import('@/views/distributioncenter/distributionthreshold.vue'),
          },
          { // 分销员门槛(消费门槛)
            path: '/consumptionthreshold',
            name: 'consumptionthreshold',
            component: () => import('@/views/distributioncenter/consumptionthreshold.vue'),
          },
          { // 分销员门槛(会员申请)
            path: '/distributorapply',
            name: 'distributorapply',
            component: () => import('@/views/distributioncenter/distributorapply.vue'),
          },
          { // 分销员门槛(储值门槛)
            path: '/storagethreshold',
            name: 'storagethreshold',
            component: () => import('@/views/distributioncenter/storagethreshold.vue'),
          },
          { // 分销员门槛(商家审核)
            path: '/distributorapply',
            name: 'distributorapply',
            component: () => import('@/views/distributioncenter/distributorapply.vue'),
          },
          { // 申请成为分销员
            path: '/Applytobeadistributor',
            name: 'Applytobeadistributor',
            component: () => import('@/views/distributioncenter/Applytobeadistributor.vue'),
          },
          { // 分销须知
            path: '/instructions',
            name: 'instructions',
            component: () => import('@/views/distributioncenter/instructions.vue'),
          },
          { // 邀请好友
            path: '/invitefriends',
            name: 'invitefriends',
            component: () => import('@/views/distributioncenter/invitefriends.vue'),
          },
          { // 分享商品
            path: '/distributionlist',
            name: 'distributionlist',
            component: () => import('@/views/distributioncenter/distributionlist.vue'),
            meta: {keepAlive: true, needCache: true},
          },
          { // 活动页
            path: '/activepage',
            name: 'activepage',
            component: () => import('@/views/show/activepage.vue'),
            meta: {keepAlive: true, needCache: true},
          },
          { // 专项储值
            path: '/specialstoredvalue',
            name: 'specialstoredvalue',
            component: () => import('@/views/user/specialstoredvalue.vue'),
          },
        ],
      },
      { // 客服人员中心
        path: '/chatserver',
        name: 'chatserver',
        component: () => import('@/views/customchat/chatserver.vue'),
      },
      { // 选择服务门店
        path: '/selectstores',
        name: 'selectstores',
        component: () => import('@/views/user/selectstores.vue'),
      },
      { // 选择开卡门店
        path: '/selectregstores',
        name: 'selectregstores',
        component: () => import('@/views/user/selectregstores.vue'),
      },
      { // 扫码通用路由
        path: '/commonwxapp/:scene',
        name: 'commonwxapp',
        component: () => import('@/views/wxacommon/commonwxapp.vue'),
      },
      { // 选择参与活动门店
        path: '/selectactivitytstores',
        name: 'selectactivitytstores',
        component: () => import('@/views/user/selectactivitytstores.vue'),
      },
      { // 完善资料
        path: '/perfectinformation/:id',
        name: 'perfectinformation',
        component: () => import('@/views/user/perfectinformation.vue'),
      },
      { // to扫码
        path: '/tosaoma',
        name: 'tosaoma',
        component: () => import('@/views/show/tosaoma.vue'),
      },
      { // to商品详情
        path: '/todetails/:itemno',
        name: 'todetails',
        component: () => import('@/views/cart/todetails.vue'),
      },
      { // 绑定推送信息
        path: '/bossAssistant/BindBossAssistantAdmin',
        name: 'bindBossAssistantAdmin',
        component: () => import('@/views/bossAssistant/BindBossAssistantAdmin.vue'),
      },
      { // 绑定扫码登录
        path: '/bossAssistant/BindBossAssistantAdmin2',
        name: 'bindBossAssistantAdmin2',
        component: () => import('@/views/bossAssistant/BindBossAssistantAdmin2.vue'),
      },
      { // 激活会员卡
        path: '/activatewxcard',
        name: 'activatewxcard',
        component: () => import('@/views/user/activatewxcard.vue'),
      },
      {
        // 活动火爆
        path: '/sorry',
        name: 'sorry',
        component: () => import('@/views/show/sorry.vue'),
      },
      { // 老板助手点击查询商品详情
        path: '/boss_order_detail',
        name: 'activaboss_order_detailtewxcard',
        component: () => import('@/views/bossAssistant/orderdetail.vue'),
      },
      { // 有效期到期跳转到页面
        path: '/end',
        name: 'end',
        component: () => import('@/views/end/index.vue'),
      },
      { // 共享公众号授权
        path: '/wxghoauthshare',
        name: 'wxghoauthshare',
        component: () => import('@/views/share/wxghoauthshare.vue'),
      },
      { // 未开启购物商城的提示
        path: '/endshopmall',
        name: 'endshopmall',
        component: () => import('@/views/end/endshopmall.vue'),
      },
      { // 购买会员
        path: '/purchasemember',
        name: 'purchasemember',
        component: () => import('@/views/plusvip/purchasemember.vue'),
      },
      { // PLUS会员
        path: '/plusvip',
        name: 'plusvip',
        component: () => import('@/views/plusvip/index.vue'),
      },
      { // 礼品详情
        path: '/giftdetail',
        name: 'giftdetail',
        component: () => import('@/views/plusvip/giftdetail.vue'),
      },
      { // 购买记录
        path: '/purchaserecords',
        name: 'purchaserecords',
        component: () => import('@/views/plusvip/purchaserecords.vue'),
      },
      { // PLUS会员方案
        path: '/renew',
        name: 'renew',
        component: () => import('@/views/plusvip/renew.vue'),
      },
      { // 直播列表
        path: '/livebroadcastlist',
        name: 'livebroadcastlist',
        component: () => import('@/views/goods/livebroadcastlist.vue'),
      },
      { // 直播
        path: '/zhibo',
        name: 'zhibo',
        component: () => import('@/views/show/zhibo.vue'),
      },
      {
        //隐私协议
        path: '/Protocol/:id',
        name: 'Protocol',
        component: () => import('@/views/Protocol/index.vue'),
      },
      { // 公众号授权
        path: '/wxghoauth',
        name: 'wxghoauth',
        component: () => import('@/views/user/wxghoauth.vue'),
      },
      { // 门店促销页面
        path: '/storepromotion',
        name: 'storepromotion',
        component: () => import('@/views/goods/storepromotion.vue'),
      }
    ],
  }];
